import React from 'react';
import PropTypes from 'prop-types';
import ForgotPassword from './ForgotPassword';
import Modal from './Modal';
import './ForgotPasswordModal.css';

export default function ForgotPasswordModal(props) {
  const onRequestClose = props.isLoading ? () => {} : props.onRequestClose;
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={onRequestClose}
      className="forgot-password-modal"
      showCloseButton={!props.isLoading}
    >
      <ForgotPassword {...props} />
    </Modal>
  );
}

ForgotPasswordModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  ...ForgotPassword.PropTypes
};



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordModal.js